import { EDIT_QUESTION, SAVE_QUESTION } from '../questions/actions'

export const editQuestionId = (state = null, action) => {
    switch (action.type) {
        case EDIT_QUESTION:
            return action.question ? action.question.id : null

        case SAVE_QUESTION:
            return null

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/editQuestionId/index.js